exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#resourcepage-dropzone[data-v-335e75ef]{min-height:126px}#resourcepage-add-files[data-v-335e75ef]{padding-top:45px}.dz-uploaded-file[data-v-335e75ef]{cursor:default}", ""]);

// exports
